function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint );
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (String )(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var contentful = require("contentful");
var contentfulUrl = "https://graphql-contentful.lululemon.com/content/v1";
// eslint-disable-next-line import/no-default-export

var ContentfulClient = /*#__PURE__*/function () {
  function ContentfulClient() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      accessToken = _ref.accessToken,
      _ref$environmentId = _ref.environmentId,
      environmentId = _ref$environmentId === void 0 ? "master" : _ref$environmentId,
      _ref$host = _ref.host,
      host = _ref$host === void 0 ? "cdn-contentful.lululemon.com" : _ref$host,
      _ref$isPreviewEnabled = _ref.isPreviewEnabled,
      isPreviewEnabled = _ref$isPreviewEnabled === void 0 ? false : _ref$isPreviewEnabled,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? "en-US" : _ref$locale,
      previewToken = _ref.previewToken,
      _ref$removeUnresolved = _ref.removeUnresolved,
      removeUnresolved = _ref$removeUnresolved === void 0 ? true : _ref$removeUnresolved,
      spaceId = _ref.spaceId,
      base64CrossSpaceToken = _ref.base64CrossSpaceToken;
    _classCallCheck(this, ContentfulClient);
    this.addCrossSpaceTokenHeader = function (headers) {
      if (base64CrossSpaceToken) {
        headers["x-contentful-resource-resolution"] = base64CrossSpaceToken;
      }
      return headers;
    };
    var baseOptions = {
      accessToken: accessToken,
      environment: environmentId,
      host: host,
      withoutUnresolvableLinks: removeUnresolved,
      space: spaceId
    };
    baseOptions.headers = this.addCrossSpaceTokenHeader({});
    this.options = isPreviewEnabled && previewToken ? _objectSpread(_objectSpread({}, baseOptions), {}, {
      accessToken: previewToken,
      host: "preview-contentful.lululemon.com"
    }) : baseOptions;
    this.client = contentful.createClient(this.options);
    this.locale = locale;
  }
  return _createClass(ContentfulClient, [{
    key: "getFilteredEntries",
    value: function getFilteredEntries(_ref2) {
      var contentType = _ref2.contentType,
        _ref2$depth = _ref2.depth,
        depth = _ref2$depth === void 0 ? 10 : _ref2$depth,
        slug = _ref2.slug,
        _ref2$filters = _ref2.filters,
        filters = _ref2$filters === void 0 ? {} : _ref2$filters;
      var slugFilter = {};
      if (slug) {
        slugFilter["fields.slug"] = slug;
      }
      return this.client.getEntries(_objectSpread(_objectSpread({
        content_type: contentType,
        include: depth,
        locale: this.locale
      }, slugFilter), filters));
    }
  }, {
    key: "graphql",
    value: function () {
      var _graphql = _asyncToGenerator(function* (_ref3) {
        var query = _ref3.query,
          variables = _ref3.variables;
        var endpoint = "".concat(contentfulUrl, "/spaces/").concat(this.options.space, "/environments/").concat(this.options.environment);
        var headers = this.addCrossSpaceTokenHeader({
          "Content-Type": "application/json",
          Authorization: "Bearer ".concat(this.options.accessToken)
        });
        try {
          var response = yield fetch(endpoint, {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
              query: query,
              variables: variables
            })
          });
          if (response.ok) {
            return response.json().then(function (result) {
              if (result.errors) {
                // eslint-disable-next-line no-console
                console.warn("GraphQLErrors: ".concat(result.errors.map(function (_ref4) {
                  var message = _ref4.message;
                  return message;
                }).join("\n")));
              }
              return result;
            });
          }
          var requestError = new Error(response.statusText);
          requestError.response = response;
          throw requestError;
        } catch (error) {
          throw new Error("Error encountered querying ".concat(contentfulUrl, ": ").concat(error.message));
        }
      });
      function graphql(_x) {
        return _graphql.apply(this, arguments);
      }
      return graphql;
    }()
  }]);
}();

export { ContentfulClient };
//# sourceMappingURL=index.js.map
